import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useI18n } from "../../../hooks/useI18n";
import { AppState } from "../../../store";
import { DiscountState } from "../../../store/discounts/types";
import { Discount } from "../../../models/Discount";
import { useDiscountEditContext } from "../index";
import { DiscountEditorDialog } from "./DiscountEditorDialog";

export const CreateDiscount = () => {
  const navigate = useNavigate();
  const discountState = useSelector<AppState, DiscountState>(s => s.discounts);
  const { discountTypes, isLoading } = discountState;
  const { createDiscount } = useDiscountEditContext();
  const { t } = useI18n();

  const onCancel = () => navigate("..");
  const onConfirm = (...params: any) => {
    createDiscount(...params);
    onCancel();
  };

  return (
    <DiscountEditorDialog
      title={t("common.actions.createCoupon")}
      isLoading={isLoading}
      discountTypes={discountTypes}
      isEditing={false}
      discount={
        { amountType: "Percentage", builtIn: false, type: 1 } as Discount
      }
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};
